import { render } from "./ReportGroup.vue?vue&type=template&id=6ed439e2&scoped=true"
import script from "./ReportGroup.vue?vue&type=script&lang=js"
export * from "./ReportGroup.vue?vue&type=script&lang=js"

import "./ReportGroup.vue?vue&type=style&index=0&id=6ed439e2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed439e2"]])

export default __exports__